var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login"},[_c('CPModal',{attrs:{"hard":false,"hasClose":false,"maxWidth":"340px"}},[_c('CPLogin')],1),_c('CPLoginPrivacyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }